(function () {
  'use strict';

  var logo = document.querySelector('.cw-floating-logo');

  if (!logo) {
    return;
  }

  var positions = ['top-right', 'bottom-right', 'top-left', 'bottom-left'];
  var collisionSelector = [
    'a:not(.cw-floating-logo)',
    'button',
    'h1',
    'h2',
    'h3',
    'input',
    'li',
    'p',
    'select',
    'summary',
    'textarea',
    '.cw-landing-bundle-card__amount',
    '.cw-landing-bundle-card__note',
    '.cw-landing-bundle-card__price',
    '.cw-landing-cta',
    '.cw-landing-eyebrow'
  ].join(',');
  var frame = null;

  function setPosition(position) {
    logo.removeAttribute('data-hidden');

    if (position === 'top-right') {
      logo.removeAttribute('data-position');
    } else {
      logo.setAttribute('data-position', position);
    }
  }

  function collidesWithContent() {
    var logoRect = logo.getBoundingClientRect();
    var clearance = 4;
    var targets = Array.prototype.slice.call(document.querySelectorAll(collisionSelector));

    return targets.some(function (element) {
      if (logo.contains(element)) {
        return false;
      }

      var style = window.getComputedStyle(element);

      if (style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0) {
        return false;
      }

      var rect = element.getBoundingClientRect();

      if (rect.width === 0 || rect.height === 0) {
        return false;
      }

      return !(
        logoRect.right + clearance <= rect.left ||
        logoRect.left - clearance >= rect.right ||
        logoRect.bottom + clearance <= rect.top ||
        logoRect.top - clearance >= rect.bottom
      );
    });
  }

  function placeLogo() {
    for (var index = 0; index < positions.length; index += 1) {
      setPosition(positions[index]);

      if (!collidesWithContent()) {
        return;
      }
    }

    setPosition('top-right');
    logo.setAttribute('data-hidden', 'true');
  }

  function requestPlacement() {
    if (frame !== null) {
      window.cancelAnimationFrame(frame);
    }

    frame = window.requestAnimationFrame(function () {
      frame = null;
      placeLogo();
    });
  }

  window.addEventListener('scroll', requestPlacement, { passive: true });
  window.addEventListener('resize', requestPlacement);
  window.addEventListener('load', requestPlacement);
  requestPlacement();
})();
